module.exports = __webpack_public_path__ + "img/watage_res_1.15e85404.gif";